import React, { useState, useEffect } from 'react';

const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const slides = [
    { id: 1, image: 'img16.jpeg' },
    { id: 2, image: 'img33.jpeg' },
    { id: 3, image: 'img19.jpeg' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) setIsMobileMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - 90,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const closeMenu = () => setIsMobileMenuOpen(false);

  const styles = `
    /* Custom animations */
    @keyframes floatImage {
      0% { transform: translateY(0); }
      50% { transform: translateY(-12px); box-shadow: 0 20px 30px -8px rgba(20, 184, 166, 0.4); }
      100% { transform: translateY(0); }
    }
    
    @keyframes slideInRight {
      0% { opacity: 0; transform: translateX(40px); }
      100% { opacity: 1; transform: translateX(0); }
    }

    .nav-links a::after {
      content: '';
      position: absolute;
      bottom: -6px;
      left: 0;
      width: 0%;
      height: 2px;
      background: #F59E0B;
      transition: 0.3s;
    }
    
    .nav-links a:hover::after {
      width: 100%;
    }

    .dropdown-content {
      position: absolute;
      top: 40px;
      left: -20px;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(12px);
      min-width: 260px;
      border-radius: 20px;
      padding: 1.2rem 0.2rem;
      box-shadow: 0 20px 35px -5px rgba(0,0,0,0.15);
      border: 1px solid rgba(20, 184, 166, 0.25);
      opacity: 0;
      visibility: hidden;
      transform: translateY(15px);
      transition: all 0.3s ease;
      z-index: 1001;
    }
    
    .group:hover .dropdown-content {
      opacity: 1;
      visibility: visible;
      transform: translateY(5px);
    }

    @media (max-width: 900px) {
      .contact-split {
        grid-template-columns: 1fr;
        gap: 2rem;
        padding: 1.8rem;
        margin-bottom: 1rem;
      }
      
      .info-col {
        margin-bottom: 0.5rem;
      }
      
      .enquiry-form {
        margin-top: 0;
      }
      
      .enquiry-form input, 
      .enquiry-form textarea, 
      .enquiry-form input[list] {
        margin-bottom: 1rem;
      }
    }

    @media (max-width: 480px) {
      .contact-split {
        padding: 1.2rem;
        border-radius: 24px;
      }
      
      .info-row {
        margin: 1rem 0;
        font-size: 0.95rem;
      }
      
      .map-live {
        height: 150px;
        margin-top: 1.2rem;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      


      <div className="main" id="home">
        {/* Hero Slider */}
        <div className="relative min-h-[80vh] flex items-center justify-center border-b border-amber-500/20 overflow-hidden">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
              style={{ backgroundImage: `url('${slide.image}')`, backgroundPosition: 'center 30%' }}
            />
          ))}

          <button
            onClick={prevSlide}
            className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/80 backdrop-blur-sm text-amber-500 rounded-full flex items-center justify-center text-2xl border border-amber-500 hover:bg-amber-500 hover:text-white transition-all z-10"
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/80 backdrop-blur-sm text-amber-500 rounded-full flex items-center justify-center text-2xl border border-amber-500 hover:bg-amber-500 hover:text-white transition-all z-10"
          >
            <i className="fas fa-chevron-right"></i>
          </button>

          <div className="relative z-5 max-w-[800px] bg-white/90 backdrop-blur-md p-8 md:p-10 rounded-[60px] text-center mx-4 shadow-2xl border border-teal-500/25">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-gray-800">
              Industrial <span className="text-amber-500">solutions</span><br />that keep you running
            </h1>
            
            <div className="flex items-center justify-center gap-2 bg-white/70 px-4 py-2 md:px-6 md:py-3 rounded-full w-fit mx-auto my-4 md:my-6 border border-teal-500/30">
              <i className="fas fa-map-pin text-teal-500"></i>
              <span className="text-sm md:text-base">SR.NO-3, KAMAL NAGAR, NEAR KURKUTE HOSPITAL, WADGAON SHERI, PUNE</span>
            </div>
            
            <p className="text-gray-600 mb-6 md:mb-8">Sales, Service & Spares – one trusted partner</p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => scrollToSection('products')}
                className="bg-amber-500 text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold shadow-lg shadow-amber-500/30 hover:bg-amber-600 hover:scale-105 transition-all flex items-center justify-center gap-2"
              >
                <i className="fas fa-cog"></i> Explore Products
              </button>
              <a
                href="tel:9359663830"
                className="border border-amber-500 text-amber-500 px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold hover:bg-amber-500/10 transition-all flex items-center justify-center gap-2"
              >
                <i className="fas fa-phone-alt"></i> Call now
              </a>
            </div>
          </div>
        </div>

        {/* Contact Bar */}
        <div className="bg-white/70 backdrop-blur-md flex flex-wrap justify-center gap-6 md:gap-12 py-3 px-4 md:py-4 md:px-8 border-y border-amber-500/20">
          <div className="flex items-center gap-2 text-gray-700">
            <i className="fas fa-clock text-teal-500 text-xl"></i>
            <span className="text-sm md:text-base">7 DAYS · 8AM–8PM</span>
          </div>
          <div className="flex items-center gap-2 text-gray-700">
            <i className="fab fa-whatsapp text-teal-500 text-xl"></i>
            <div className="flex gap-2">
              <a href="https://wa.me/919359663830" className="hover:text-amber-500 transition-colors text-sm md:text-base">9359663830</a>
              <span>/</span>
              <a href="https://wa.me/918888551919" className="hover:text-amber-500 transition-colors text-sm md:text-base">8888551919</a>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Float */}
      <a
        href="https://wa.me/919359663830"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-[#25d366] w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center text-white text-3xl md:text-4xl shadow-lg shadow-[#25d366]/50 z-[100] hover:scale-110 transition-transform"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </>
  );
};

export default Hero;